import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";

import * as departmentApi from "../../api/departmentApi/departmentApi";
import {EQDepartment, initialDepartmentList} from "../../models/serverModels/EQDepartment";
import DepartmentForm from "./DepartmentForm";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

const departmentSchema = yup.object({
  name: yup.string().required("부서명을 입력해주세요"),
});

const CreateDepartment = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EQDepartment>,
    Params.Create<EQDepartment>
  >({
    api: departmentApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Department`);
        queryClient.invalidateQueries("DocumentList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EQDepartment>({
    defaultValues: initialDepartmentList,
    resolver: yupResolver(departmentSchema),
  });

  const onSubmit: SubmitHandler<EQDepartment> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initialDepartmentList, ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="부서 추가" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DepartmentForm />
          <ConfirmButtonGroup link={`/Department`} cancelText="취소" confirmText="추가" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateDepartment;
